<script lang="ts" setup>
    import { computed } from "vue";
    import HighlightsImage from "@/components/HighlightsImage.vue";
    import type { Cta } from "@/helpers/builder-init/index";

    type ContentPosition = "image-left" | "image-right";
    interface TextProp {
        collabBadge?: string;
        texturedBackground?: string;
        bgColor: string;
        textColor: string;
        eyeBrowColor: string;
        titleColor: string;
        eyebrow: string;
        title: string;
        description: string;
        descriptionPosition: string;
        cta: Cta;
    }
    let props = defineProps({
        elementId: {
            type: String,
            required: false
        },
        image: {
            type: String,
            required: true
        },
        imageAlt: {
            type: String,
            required: false
        },
        contentPosition: {
            type: String as PropType<ContentPosition>,
            required: true,
            default: "image-right"
        },
        textProps: {
            type: Object as PropType<TextProp>,
            required: true,
            default() {
                return {
                    bgColor: "rothcoCharcoal",
                    eyebrow: "BUILT FOR THE CHALLENGE",
                    title: "Purpose-Driven Gear for Every Adventure",
                    description:
                        "The convergence of Rothco and Fred Bear Camo brings together an expert in development of not only camo patterns, but styles made to last.",
                    cta: {
                        label: "SHOP ROTHCO x BEAR ARCHERY",
                        url: {
                            urlType: "general",
                            generalUrl: {}
                        }
                    }
                };
            }
        }
    });

    let highlightImageProps = computed(() => {
        return {
            ...props,
            interactive: false
        };
    });
</script>
<template>
    <HighlightsImage v-bind="highlightImageProps" />
</template>
